import { ChangeDetectionStrategy, Component, inject, OnInit, ViewEncapsulation } from '@angular/core';
import { RequestFactory } from '@app/common/services/request-factory';
import { GridModule } from '@progress/kendo-angular-grid';
import { LoaderComponent } from '@progress/kendo-angular-indicators';
import { AssetTeam, Report, Scenario, Table } from "app/shared/models";

@Component({
  selector: 'scenario-reports',
  templateUrl: 'scenario-reports.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./scenario-reports.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    GridModule,
    LoaderComponent,
  ],
})

export class ScenarioReportsComponent implements OnInit {
  private requestFactory = inject(RequestFactory);

  public reports: Report[];
  public reportSelected: boolean;

  public assetTeams: AssetTeam[];
  public scenarios: Scenario[];

  public selectedAssetTeams = [];
  public selectedScenarios = [];

  public loading: boolean = false;

  ngOnInit() {
    this.getReports();
  }

  selectionChanged(event) {
    this.reportSelected = event.selected;
  }

  getReports() {
    this.loading = true;

    let requestBuilder = this.requestFactory.createTypedRequest(Report, Table.Reports);
    requestBuilder.getTyped().subscribe(t => {
      this.reports = t;
      this.loading = false;
    })
  }
}